// Add more healthPlanCodes when there are more
export enum HealthPlanCode {
	DIABETES = 'diabetes',
	BABY = 'meddibaby',
	THERAPIST = 'therapist',
	OBESITOLOGY = 'obesity',
	OBESITOLOGY_THERAPIST = 'obesityTherapist',
	KDAR = 'kdar',
	DENT = 'meddident',
}
